const VERSION: string = '0.1.7-prod.107'
export default VERSION;
